import React from "react";
import { motion } from "framer-motion";
import Button from "../Components/Button";
import { useNavigate } from "react-router-dom";
import { BRAND } from "../config/brand";

function SectionFive() {

  let nevigate = useNavigate();

  return (
    <div className="main-section-five">
      <motion.div
        className="sectionfive-left"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h1>Step into the next phase of blue-lit digital finance.</h1>
      </motion.div>

      <motion.div
        className="sectionfive-right"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <p>
          {BRAND.name} blends real-world asset discipline with a cinematic Web3
          identity: precise, luminous, and built for holders who want clarity in
          volatile markets.
        </p>

        <motion.div className="section-five-btns">
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            {/* <Button text="Details" className="light" /> */}
            <a href={BRAND.whitepaperUrl} target="_blank" rel="noopener noreferrer">
  <Button text="Token Details" className="light" />
</a>
          </motion.div>

          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button onClick={() => nevigate("/#hero")} text={`Buy ${BRAND.tokenSymbol}`} className="transparent" />
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default SectionFive;
